import {listTiposPericia, deleteTipoPericia} from '@/domain/cadastro/services'
import window from './window/window.js'
import parse from '../tiposbem/parse'

export default {
  pageTitle: 'Tipos de Perícias/Observações',
  columns: [
    {
      name: 'nome',
      required: true,
      label: 'Nome',
      align: 'left',
      field: 'nome',
      sortable: true,
      parser: function (props) {
        return props.nome
      }
    },
    /*{
      name: 'tipo',
      required: true,
      label: 'Tipo(s) de Bem',
      align: 'left',
      field: 'tipo',
      class: 'td-limit l-130',
      sortable: true,
      parser: parse
    },*/
    {
      name: 'descricao',
      required: true,
      label: 'Descrição',
      align: 'left',
      field: 'descricao',
      sortable: true,
      class: 'td-limit l-130',
      parser: function (props) {
        return props.descricao
      }
    },
    {
      name: 'active',
      required: true,
      label: 'Situação',
      align: 'left',
      field: 'active',
      sortable: true,
      parser: function (props) {
        return props.active ? 'Ativo' : 'Inativo'
      }
    },
    {
      name: 'options',
      required: true,
      label: '',
      field: 'options',
      sortable: false
    }
  ],
  resolve: listTiposPericia,
  methods: {
    // window: window
    abrir: function (id) {
      window.call(this, {id: id, table: this.table})
    },
    novo: function () {
      window.call(this, {})
    },
    excluir: deleteTipoPericia
  }
}
